export enum AnnouncementModalModes {
  VIEW = "view",
  EDIT = "edit",
  CREATE = "create",
}
